module.exports = __webpack_public_path__ + "img/fig03.11e90f0e.jpg";